import React, { memo, useEffect, useState } from 'react'

import { Dropdown } from '../Dropdown'

import './style.css'

interface IProps {
  currencies: string[]
  value: string
  onSelect: (currencyName: string) => void
}

const SimpleCurrenciesDropdown = ({ currencies, value, onSelect }: IProps) => {
  const [searchValue, setSearchValue] = useState('')
  const [currentCurrencies, setCurrentCurrencies] = useState(currencies)

  useEffect(() => {
    if (currencies !== currentCurrencies) {
      setCurrentCurrencies(currencies)
    }
  }, [currencies])

  const handleSearchChange = (val: string) => {
    let newCurrencies: string[] = []
    if (val.length > 0) {
      newCurrencies = [
        ...currencies.filter(
          (currency) => currency.toLowerCase().indexOf(val.toLowerCase()) !== -1,
        ),
      ]
    } else {
      newCurrencies = currencies
    }
    setSearchValue(val)
    setCurrentCurrencies(newCurrencies)
  }

  return (
    <Dropdown
      dropdownClass='currency-dropdown csas-selectbox'
      currentValue={value}
      searchValue={searchValue}
      onSearch={handleSearchChange}
      searchEnabled
      iconClass={`csas-flags ${value}`}
    >
      {currentCurrencies.length > 0 ? (
        <>
          {currentCurrencies.map((currency, index) => (
            <CurrencyItem currency={currency} onSelect={onSelect} key={index} />
          ))}
        </>
      ) : (
        <div>no data</div>
      )}
    </Dropdown>
  )
}

interface ICurrencyItem {
  currency: string
  onSelect: (value: string) => void
}

const CurrencyItem = ({ currency, onSelect }: ICurrencyItem) => {
  const handleClick = () => onSelect(currency)
  return (
    <div className='simple-currency-drowpdown-item' onClick={handleClick}>
      <div className={'csas-flags ' + currency} />
      <div>{currency}</div>
    </div>
  )
}

export default SimpleCurrenciesDropdown
